export const SUPPLIER = '[Supplier]'

export const CREATE_SUPPLIER = `${SUPPLIER} CREATE_SUPPLIER`
export const GET_SUPPLIERS = `${SUPPLIER} GET_SUPPLIERS`
export const SET_SUPPLIERS = `${SUPPLIER} SET_SUPPLIERS`
